export const capitalize = (e) => {
  let event = e.target.value;
  const value = event
    ?.split('')
    .map((letter, i) => (i === 0 ? letter.toUpperCase() : letter))
    .join('');
  return value;
};
